import { rgba, tint, shade, lighten, darken, transparentize } from 'polished'

const getFont = (font) => {
  return {
    css: `"${font.family}", sans-serif;`
  }
}

const getColorAverage = (black, white) => {
  return {
    r: Math.round(((black.r * 0.5) + (white.r * 1.5)) / 2),
    g: Math.round(((black.g * 0.5) + (white.g * 1.5)) / 2),
    b: Math.round(((black.b * 0.5) + (white.b * 1.5)) / 2),
    a: Math.round(((black.a * 0.5) + (white.a * 1.5)) / 2)
  }
}

const getColor = (color) => {
  const hex = rgba(color.r, color.g, color.b, color.a)

  return {
    shade100: { css: tint(0.6, hex) },
    shade200: { css: tint(0.3, hex) },
    shade300: { css: hex },
    shade400: { css: shade(0.3, hex) },
    shade500: { css: shade(0.6, hex) }
  }
}

const getGrayColor = (color) => {
  const hex = rgba(color.r, color.g, color.b, color.a)

  return {
    shade100: { css: lighten(0.2, hex) },
    shade200: { css: lighten(0.1, hex) },
    shade300: { css: hex },
    shade400: { css: darken(0.1, hex) },
    shade500: { css: darken(0.2, hex) }
  }
}

const getWhite = (color) => {
  const hex = rgba(color.r, color.g, color.b, color.a)

  return {
    shade100: { css: hex },
    shade200: { css: darken(0.025, hex) },
    shade300: { css: darken(0.05, hex) },
    shade400: { css: darken(0.075, hex) },
    shade500: { css: darken(0.1, hex) }
  }
}

const getBlack = (color) => {
  const hex = rgba(color.r, color.g, color.b, color.a)

  return {
    shade100: { css: lighten(0.4, hex) },
    shade200: { css: lighten(0.3, hex) },
    shade300: { css: lighten(0.2, hex) },
    shade400: { css: lighten(0.1, hex) },
    shade500: { css: hex }
  }
}


const getElevation = (theme, factor) => {
  const y = [0, 0.125, 0.25, 0.5, 0.75][theme.elevation - 1] * factor
  const x = 0
  const blur = [0, 0.5, 1, 2, 3][theme.elevation - 1] * factor
  const spread = 0
  const opacity = [0.2, 0.175, 0.15, 0.125, 0.1][theme.elevation - 1]
  const color = transparentize(1 - opacity, rgba(theme.colors.black.r, theme.colors.black.g, theme.colors.black.b, theme.colors.black.a))

  return {
    y,
    x,
    blur,
    spread,
    color,
    css: `${x}rem ${y}rem ${blur}rem ${spread}rem ${color}`
  }
}

const getRoundness = (theme, factor) => {
  const borderRadius = [0, 0.25, 0.5, 1, 2][theme.roundness - 1] * factor

  return {
    borderRadius,
    css: `${borderRadius}rem`
  }
}

const getSpacing = (theme, factor) => {
  const spacing = [0.75, 1.5, 3][theme.spacing - 1] * factor

  return {
    spacing,
    css: `${spacing}rem`
  }
}

export const createTheme = (theme) => {
  return {
    width: {
      width: 74,
      css: '74rem'
    },
    fonts: {
      primary: getFont(theme.fonts.primary)
    },
    colors: {
      primary: getColor(theme.colors.primary),
      gray: getGrayColor(getColorAverage(theme.colors.black, theme.colors.white)),
      black: getBlack(theme.colors.black),
      white: getWhite(theme.colors.white),
    },
    elevation: {
      small: getElevation(theme, 0.5),
      medium: getElevation(theme, 1),
      large: getElevation(theme, 1.5)
    },
    roundness: {
      small: getRoundness(theme, 0.5),
      medium: getRoundness(theme, 1),
      large: getRoundness(theme, 2)
    },
    spacing: {
      small: getSpacing(theme, 0.5),
      medium: getSpacing(theme, 1),
      large: getSpacing(theme, 1.5)
    }
  }
}


// WEBPACK FOOTER //
// ./src/shared/theme/index.js